<template>
  <div>
      <div v-if="journeyRecords.length==0" class="container-fluid fade-in-top row" :class="{'main-content-margin-top': !isPersonaView}">
        <div class="col">
          <span v-if="!activeSearch" class="text-muted">Enter search values above</span>
          <span v-else class="text-muted">No results found</span>
        </div>
      </div>
    <div id="panel_journey" 
    v-cloak v-show="!loading && (activeView=='search' || activeView=='personas') && journeyRecords.length > 0" 
    class="container-fluid archiver-content fade-in flex-grow-1 px-0" :class="{'main-content-margin-top': !isPersonaView}" tag="panel-journey"
    @click="hidePopover()">

      <div style="padding-top: 10px; padding-bottom: 10px;" v-show="recordsLength==0"><span class="text-muted" 
        html="resultsText + filterWarningText"></span></div>
        <div id="canvas_container" class="bg-white" style="display: block;">
          <div class="print-only" style="margin-left: 30px; margin-bottom:-20px; padding-bottom:0px;"><img src="images/print_logo.png" width="20%" height="20%" style="display: inline-block; vertical-align: baseline; line-height: .65in; margin-top:0px;margin-bottom:0px;"/><h3 style="display:inline-block; color: #382b2b;line-height: .69in; margin-top:0px;margin-bottom:0px;">&nbsp;Customer Journey View</h3></div>
          <div id="canvas" class="canvas" v-bind:class="{carousel: journeySettings.carouselView, persona: isPersonaView}">

            <div v-for="(email, index) in journeyRecords" class="active" style="position: relative;" :class="{'last-per-row': !journeySettings.carouselView && index+1 != journeyRecords.length && (index+1) % journeySettings.itemsPerRow==0, 'first-per-row': !journeySettings.carouselView && index % journeySettings.itemsPerRow==0, 'last-row-item': !journeySettings.carouselView && index >= lastRowIndex}">
              <div v-if="email.doc_type=='pdf'" class="journeyFrame pdf-thumb" v-bind:ref="'jframe' + index" style="padding-top: 65px;text-align:center;"><img src="images/pdf_icon.png"></div>
              
              <!-- iframe or SMS display box -->
              <div v-if="email.channel!='s'" class="frame-holder"><iframe v-bind:key="'iframe' + index"  v-if="email.doc_type!='pdf'" class="journeyFrame" v-bind:ref="'jframe' + index" :src="getEmailUrl(email)":alt="email.campaign_name" v-on:load="function(e){resizeThumbframe(660,e.target,true); if (email.doc_type!='pdf') setMasks(e.target);}" scrolling="no"></iframe></div>
              <div v-else-if="email.channel=='s'" class="frame-holder frame-holder-sms">
                <pre>{{email.message}}</pre>
              </div>
              <!-- /iframe or SMS display box -->

              <div v-if="journeySettings.carouselView" v-bind:ref="'jmask' + index" class="pop-link" style="position:absolute;top:0;left:0;width:100%;height:100%; z-index:100;" v-on:click="function(){showJourneyItem(index)}"><a href="#" v-on:click="function(){showJourneyItem(index)}"><span class="glyphicons glyphicons-zoom-in"></span></a></div>
              <div v-else v-bind:id="'ji_' + index" v-bind:ref="'jmask' + index" style="position:absolute;top:0;left:0;width:100%;height:100%; z-index:200; cursor: pointer;" 
                
                @click.stop="showEmailPopover('ji_' + index,email)"
                v-on:dblclick="function(){showJourneyItem(index)}">&nbsp;</div>
              <div class="title">
                <template v-if="journeySettings.carouselView">
                  <span class="badge text-white float-left" :class="getJourneyEventStatusClass(email)">{{index+1}}</span>
                  <div class="float-right">
                    <a href="#" v-on:click.prevent="function(){showJourneyItem(index)}">View <span class="glyphicons glyphicons-zoom-in"></span></a>
                  </div>
                  <span class="tight">
                    <span class="font-weight-semibold">Sent:</span> {{email.formatted_dt}}<br/>
                    <span class="font-weight-semibold">Subject:</span> {{email.subject}}
                    <div>
                      <span class="font-weight-semibold">Campaign:</span> {{email.campaign_display_name}}</div>
                  </span>
                </template>
                <template v-else>
                  <span class="badge text-white float-left" :class="getJourneyEventStatusClass(email)">{{index+1}}</span>
                  <span class="tight" style="max-width: 120px"><span class="font-weight-semibold">{{email.formatted_dt}}</span><br/>
                    {{email.campaign_display_name}}</span>
                </template>
              </div>
            </div>
            <div class="last"></div>
          </div>
        </div>
        <div class="bg-light pt-2 d-block pb-2 d-print-none" style="width: 100%;position: absolute; bottom: 0; left: 0;">
          <form class="form-inline" autocomplete="off" style="padding-top: 0px; padding-left: 25px;" data-bind="visible: recordsLength >0">
            <div class="form-group" v-show="journeySettings.view_mode=='journey'">
            {{journeyRecords.length + ' of ' + recordsLength + ' messages shown'}}&nbsp;&nbsp;
            </div>
            <div class="btn-group dropup ml-2">
              <button type="button" class="btn btn-sm btn-dropdown-default mr-2 dropdown-toggle" 
              style="min-width: 75px;" data-toggle="dropdown"><span class="font-weight-semibold">Limit results:</span> to {{journeySettings.itemsPerPage}} messages</button>
              <ul class="dropdown-menu dropup">
                <template v-for="setting in journeySettings.perPageOptions">
                <a v-bind:class="{active: setting==journeySettings.itemsPerPage}" class="dropdown-item" href="#" v-on:click="setItemsPerPage(setting)">{{setting}}</a>
                </template>
              </ul>
            </div>
            <div class="btn-group btn-group-sm mr-2">
              <button type="button" class="btn btn-outline-gray" data-toggle="tooltip" data-placement="top" v-bind:class="{active: !journeySettings.sortAsc}" v-on:click.prevent="function() {setJourneySort(false)}" title="Sort from oldest to most recent">
                  <span class="glyphicons glyphicons-sort-by-attributes"></span>
              </button>
              <button type="button" class="btn btn-outline-gray" data-toggle="tooltip" data-placement="top" v-bind:class="{active: journeySettings.sortAsc}" v-on:click.prevent="function() {setJourneySort(true)}" title="Sort with newest first">
                  <span class="glyphicons glyphicons-sort-by-attributes-alt"></span>
              </button>
            </div>        
            <div class="btn-group btn-group-sm mr-2">
              <button type="button" class="btn btn-outline-gray" data-toggle="tooltip" data-placement="top" v-bind:class="{active: !journeySettings.carouselView}" v-on:click.prevent="function() {setThumbnailView(true)}" title="Small thumbnail view">
                  <span class="glyphicons glyphicons-show-big-thumbnails"></span>
              </button>
              <button type="button" class="btn btn-outline-gray" data-toggle="tooltip" data-placement="top" v-bind:class="{active: journeySettings.carouselView}" v-on:click.prevent="function() {setThumbnailView(false)}" title="Large thumbnail view">
                  <span class="glyphicons glyphicons-pictures"></span>
              </button>
            </div>        
            <div class="btn-group">
              <button type="button"  data-toggle="tooltip" data-placement="top" class="btn btn-default btn-sm" title="Print Customer Journey" onclick="window.print();">
                  <span class="glyphicons glyphicons-print"></span>
              </button>
            </div>
          </form>          
        </div>
    </div>
    <EmailPopover ref="popoverComponent" :isPersonaView="isPersonaView" />
  </div>
</template>
<script>
import {mapState} from 'vuex'
import DateFormatting from '@/mixins/date-formatting'
import Email from '@/mixins/email'
import EmailPopover from './journey-view-email-popover'

const debounce = require("lodash").debounce; 
import {parseJSON} from 'date-fns'
import {zonedTimeToUtc,utcToZonedTime,format} from 'date-fns-tz'
import {getLocalStorage} from '@/js/sageflo/ui-helpers.js'

export default {
  components: {EmailPopover},
  mixins: [Email,DateFormatting,],
  data: function(){ return {
    journeySettings: {
      itemsPerRow: 0,
      view_mode: 'journey',
      sortAsc: getLocalStorage("journeySortAsc",false,true),
      itemsPerPage: getLocalStorage("journeyItemsPerPage",40),
      perPageOptions : [20,40,60,80,100],
      carouselView: getLocalStorage("journeyThumbnails",false,true)
    },
    popperInstance: null,
  }},
  computed: {
    ...mapState({
      uiConfig: (state)=>state.user.uiConfig,
      results: (state)=>state.search.emails,
      loading: (state)=>state.ui.loading,
      activeView: (state)=>state.ui.activeView,
      detailView: (state)=>state.ui.detailView,
      activeSubAccount: (state)=>state.ui.activeSubAccount,
      viewType: (state)=>state.ui.viewType,      
      selectedEmail: (state)=>state.search.selectedEmail,
      activeSearch: (state)=>state.search.activeSearch,
      resultsSearchType: (state)=>state.search.resultsSearchType,
      emailsearchParams: (state)=>state.search.searchParams,
      filterEmail: (state)=>state.search.filterEmail,
      paginator: (state)=>state.search.paginator,
      resend: (state)=>state.search.resend,
      showSmsEvents: (state)=>state.user.showSmsEvents,
      showEmailEvents: (state)=>state.user.showEmailEvents,
    }),
    recordsLength: function() {
      return this.results.length;
    },
    journeyRecords: function() {
      // NOTE: need to add filter to limit to whatever journeySetting results per page is
      let theRecords = [];
      if (this.uiConfig && this.results){
        theRecords = this.results.map((item)=>{
          item.campaign_display_name = (item.campaign_name) ? item.campaign_name : (item.subject) ? item.subject : (item.doc_type=='pdf') ? 'PDF document' : '';
          item.formatted_dt = format(parseJSON(item.sent_dt),"MM/dd/yyyy h:mm aaaaa'm' z",this.uiConfig.time_zone); 
          //moment(item.sent_dt).tz(this.uiConfig.time_zone).format('MM/DD/YY h:mm a z');
          return item;
        }); 
      }

      if (this.journeySettings.sortAsc) {
        return theRecords.slice(0,this.journeySettings.itemsPerPage);
      } else {
        return theRecords.reverse().slice(0,this.journeySettings.itemsPerPage);
      }
    },
    carouselItemWidth: function() {
      return (($('#panel_journey').width()+70)/3)-26;
    },
    lastRowIndex:  function() {
      var rows = parseInt(this.journeyRecords.length / this.journeySettings.itemsPerRow);

      if (rows>0) {
        if (rows > 1 && this.journeyRecords.length % this.journeySettings.itemsPerRow == 0) {
          rows = rows -1;
        }
        return rows * this.journeySettings.itemsPerRow;
      } else {
        return 0;
      }
    },
    rowCount: function() {
      return parseInt(this.journeyRecords.length / this.journeySettings.itemsPerRow);
    },
    isPersonaView() {
      return this.activeView=='personas';
    }


  },
  methods:{
    redrawJourneyView: debounce(function(){this.drawJourneyView(true)},50),
    drawJourneyView(fromResizeEvent){
      let that = this;
      if (fromResizeEvent==undefined || (fromResizeEvent && this.journeySettings.carouselView)) { 
        //console.log(fromResizeEvent && this.journeySettings.carouselView);
        try {
          $('iframe.journeyFrame').each(function(index,element){
            var frame = this;
            $(frame).data('scaled',false);
            var state = frame.contentWindow.document.readyState;
            if (state =="complete" || state =='interactive') {
              that.resizeThumbframe(660,frame);
            }
          });
        } catch(e) {
          console.warn(e);
        }        
      }

      var itemsPerRow = parseInt(($('#panel_journey').width()-30) / 185);

      if (itemsPerRow != this.journeySettings.itemsPerRow) {
        this.journeySettings.itemsPerRow = itemsPerRow;
      }
      
    },
    setJourneySort: function(ascending) {
      localStorage.setItem("journeySortAsc", ascending);
      this.journeySettings.sortAsc = ascending;

    },
    setThumbnailView: function(show) {
      localStorage.setItem("journeyThumbnails", !show);
      this.journeySettings.carouselView = !show;
      this.drawJourneyView();
    },
    setItemsPerPage: function(items) {
      localStorage.setItem("journeyItemsPerPage", items);
      this.journeySettings.itemsPerPage=items;
    },
    showJourneyItem: function(index) {
      this.$store.commit("setSelectedEmail",this.journeyRecords[index]);
      // hide any popover that might be displayed
      //this.closePopovers();

      let view = this.isPersonaView ? 'persona-detail' : 'detail'
      this.$store.commit("setActiveView",view);
    },
    cleanupPriorSearch: function() {
      for (item in this.journeyRecords){
        $("#jframe" + item).src='';
      }
    },
    formatPopoverText: function(text) {
      var fontSize = '12';
      if (text==undefined || text==null) {
        return '';
      }

      if (text.length > 30) {
        fontSize = (text.length > 50) ? '10' : '11';
      }

      return "<span style='font-size:" + fontSize + "px;'>" + text + "</span>"; 

    },
    hidePopover(){
      this.$refs.popoverComponent.close();
    },

    getJourneyEventStatusClass(item) {
      if (item.channel == 's' && this.showSmsEvents && item.events) {
        if (item.events.unsub) {
          return 'bg-danger';
        } else if (item.events.c) {
          return 'bg-primary';
        } else if (item.events.sub) {
          return 'bg-success';
        } else {
          return 'bg-gray';
        }
      } else if (this.showEmailEvents && item.events){
        if ((item.events.comp && item.events.comp.length > 0) || (item.events.unsub && item.events.unsub.length > 0)) {
          return 'bg-danger';
        } else if (item.events.b && item.events.b.length > 0) {
          return ['bg-yellow','text-dark'];
        } else if (item.events.c && item.events.c.length > 0) {
          return 'bg-primary';
        } else if (item.events.o && item.events.o.length > 0) {
          return 'bg-success';
        } else {
          return 'bg-gray';
        }
      } else {
        return 'bg-gray';
      }

    },

    resizeThumbframe(eWidth, frame, append) {
      //console.log("resizeThumbframe")
      if (!$(frame).scaled) {
        frame.style.width = eWidth + 'px';

        var ifWidth = (this.journeySettings.carouselView) ? this.carouselItemWidth-25 : 165;
        var ifHeight = (this.journeySettings.carouselView) ? 553 : 208;
        var scalePct = ifWidth/eWidth;
                
        if (eWidth>=ifWidth) {
          frame.style.transition='transform 150ms';
          frame.style.minWidth=eWidth+'px;';
          frame.style.msTransform='scale('+scalePct+')';
          frame.style.msTransformOrigin='0% 0%';
          frame.style.webkitTransform='scale('+scalePct+')';
          frame.style.webkitTransformOrigin='0% 0%';
          frame.style.transform='scale('+scalePct+')';
          frame.style.transformOrigin='0% 0%';          
        }


        frame.style.height = (1/scalePct * ifHeight) + 'px';
        $(frame).data('scaled',true);
      }
      if (append) {
        $(frame).on('click', function(e) {
          return false;
        });
        $(frame).on('mousedown', function(e) {
          if (e.button==2) return false;
          return true;
        });              
      }

    },
    showEmailPopover(itemId,email){
      const reference = document.querySelector("#" + itemId);
      if (this.$refs.popoverComponent.isVisible() && reference==this.$refs.popoverComponent.getReference()) {
        this.$refs.popoverComponent.close();
        return;
      }
      this.$store.commit("setSelectedEmail",email);
      this.$refs.popoverComponent.showEmailPopover(reference,email);
    },

  },
  created: function() {
    this.$eventBus.$on("sideBarToggled", (params) => {
      let that = this;

      setTimeout(()=>{
        console.log('redrawin')
        that.drawJourneyView(true); 
      },500)
    });
  },
  mounted: function() {
    $('#panel_journey').tooltip({selector: '[data-toggle="tooltip"]', trigger: 'hover', html:true, delay: { "show": 500, "hide": 100 }});
    /*
    $('#panel_journey').popover({
      //find any elements that have something in data-content
      selector: '[data-toggle="popover"]',
      container: 'body',
      delay: { "show": 500, "hide": 100 },
      html: true,
      trigger: 'click',
      boundary: 'viewport',
    });
    $('#panel_journey').parent().click(function(){$('.popover').popover('hide');});
    $(document).on('keydown',function(e){
      if (e.which==27) $('.popover').popover('hide');
    });
    */    
    this.drawJourneyView();

  },
  watch: {
    'results': function(newVal, oldVal) {
      if (newVal.length > this.journeySettings.itemsPerPage) {
        if (this.journeySettings.itemsPerPage<100 && newVal.length <=100) {
          var msg = 'The first '+this.journeySettings.itemsPerPage+' results out of '+newVal.length+' are being displayed. To see all results, increase the value in the <span class="font-semibold">limit results</span> setting below.';
        } else {
          var msg = 'The Customer Journey View cannot display more than <b>100</b> results. The first '+this.journeySettings.itemsPerPage+' results out of ' + newVal.length + ' are being displayed. Please narrow your search to return fewer total records ' + ((this.journeySettings.itemsPerPage<100) ? ', or increase the value in the <span class="font-semibold">limit results</span> setting below' : '') + '.<br/><br/><i>Hint: use a shorter date range and/or specific campaign type.</i>';
        }

        this.$eventBus.$emit("showStatus",{
          msg: msg,
          title: `More than ${this.journeySettings.itemsPerPage} messages returned`,
        });

      }
    }
  }
}

</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap');

.frame-holder-sms {
  background-color: var(--indigo);
  color: #ffffff;
  padding: .25rem .35rem .4rem .35rem;
  /*font-size: 1rem;
  line-height: 1.3rem;*/

}
.frame-holder-sms pre {
  overflow-x: auto;
  white-space: pre-wrap;
  white-space: -moz-pre-wrap;
  white-space: -pre-wrap;
  white-space: -o-pre-wrap;
  font-family: 'Source Sans Pro';
  background-color: transparent;
  color: #ffffff;
  font-size: .8rem;
  word-wrap: break-word;
  border: none;
}


.canvas {
  background-image: url('/images/bg-lines.png');
  background-size: 10px;
  background-position: 0px 9px;
  background-repeat: repeat;
  background-attachment: local;
  display: flex;
  flex-wrap: wrap;
  padding-left: 30px;
  max-height: calc(100vh - 147px);
  overflow-y: auto;
  overflow-x: hidden;
  margin-top: 0px;
  padding-top: 0px;
  position: relative;
  width: 100% !important;
}

.canvas.persona {
  max-height: calc(100vh - 97px);  
}

#canvas.carousel {
  background-image: none;
  scroll-snap-type: y mandatory;
  scroll-snap-stop: always;
  scroll-padding-top: 10px;
  padding-left: 0px;
  padding-bottom: 50px;
}

#canvas.carousel div.active:nth-child(3n+1) {
  scroll-snap-align: start;
}

.canvas div.active {
  display: inline-block;
  height: 210px;
  width: 165px;
  z-index: 200;
  border: 1px solid #ddd;
  background-color: #fff;
  vertical-align: top;
  margin-top: 10px;
  margin-bottom: 65px;
  margin-left: 20px;
  overflow: display;
  box-shadow: 0px 0px 3px #ccc;
  border-radius: 3px;
}

.canvas div.active .frame-holder {
  height: 210px;
  width: 163px;
  overflow: hidden;
}

.canvas.carousel div.active .title {
  padding-top: 5px;
  margin-top: calc(100vh - 220px);
}

.canvas div.active.last-row-item {
  margin-bottom: 45px;
}

.pop-link {
  padding-top: 5px;
  padding-right: 20px;
  text-align: right;
}

.pop-link:hover {
  background-color: transparent;
  mix-blend-mode: hard-light;
  cursor: pointer;
}

.pop-link a {
  visibility: hidden;
  font-size: 100px;
  color: #777;
}

.pop-link:hover a {
  visibility: visible;
}

@media screen {

  #canvas_container {
    min-height: 250px; 
    margin-top:-15px; 
    height: calc(100vh - 147px);
  }

  .last {
    margin-top: 25px;
    min-width: 10px;
    flex-grow: 7;
    height: 210px;
    display: inline-block;
    background-color: #ffffff;
  }

  .canvas div.active:after {
    content: '';
    display: inline-block;
    position: absolute;
    left: 169px;
    top: 108px;
    width: 10px;
    height: 20px;
    overflow: hidden;
    z-index: 0;
  }

  .canvas div.active.last-per-row:after {
    content: url('/images/bg-endcap.png');
    display: inline-block;
    position: absolute;
    left: 175px;
    top: 114px;
    width: 200px;
    height: 154px;
    overflow: hidden;
    z-index: 0;
  }
  .canvas div.active.first-per-row {
    scroll-snap-align: start;
  }
  .canvas div.active.first-per-row:before {
    content: url('/images/bg-startcap.png');
    display: inline-block;
    position: absolute;
    left: -58px;
    top: -27px;
    width: 50px;
    height: 154px;
    overflow: hidden;
    z-index: 1000;
  }
  .canvas div.active:first-child:before {
    content: '';
    display: inline-block;
    position: absolute;
    background-color: #ffffff;
    left: -51px;
    top: 114px;
    width: 49px;
    height: 10px;
    overflow: hidden;
    z-index: 1;
  }
  
  .lastItemPerRow {

  }

  .canvas.carousel div.active .frame-holder {
    height: calc(100vh - 220px);
    width: 100%;
    overflow: hidden;
  }

  .canvas.carousel div.active {
    height: calc(100vh - 220px);
    width: calc((100% - 80px) / 3);
    margin-bottom: 60px;
  }

  .canvas.carousel .title .tight {
    font-size: 1.1em;
    max-width: 300px;
  }

  .canvas.carousel .title div a {
    visibility: hidden;
    font-size: 1.1em;
  }

  .canvas.carousel div.active:hover .title div a {
    visibility: visible;
  }

  .canvas.carousel div.active:after {
    content: '';
  }

}
.canvas div.pdf-thumb {
  position: relative;
  width: 100%;
  height: 100%;
  border: none;
  z-index: 100;
}

div.pdf-thumb > img {
  opacity: 0.7;
}

.canvas iframe {
  position: relative;
  width: 100%;
  height: 100%;
  border: none;
  z-index: 100;
}
.canvas span.journeyDiv {
  display: inline-block;
  position: relative;
  width: 100%;
  height: 100%;
  border: none;
  z-index: 100;
}

.canvas .title {
  width: inherit;
  display: block;
  top: 0px; 
  font-size: 11px;
  position: absolute;
  margin-top: 215px;
  z-index: 100;
}

.canvas div.active:hover .title {
  color: #4e9aac;
}

.canvas div.active:hover .badge {
  background-color: #4e9aac;
}

.canvas div.active:hover {
  border: 1px solid var(--primary);
  box-shadow: 0px 0px 4px var(--indigo);
  transition: all 0.2s;
}
    
.canvas .title .badge {
  margin-right: 5px;
  margin-top: 5px;
}  

.canvas .title .tight {
  display: inline-block;
  max-width: 130px;
  overflow: hidden; 
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media screen {
  .print-only {
    visibility: hidden;
    display: none;
  }
}

@media print {
  .print-only {
    visibility: visible;
    display: '';
  }  
}

@media print {
  .canvas {
    max-height: none;
    background-image: none;
  }
  #panel_journey, #panel_journey div {float: none!important;}
  #panel_journey {
    position: absolute;
    display: block;
    top: 0px;
    margin-top: 0px;
    padding-top: 0px;
    overflow: visible;
  }
  #canvas_container {
    background-color: var(--pink);
    position: relative;
    display: block;
    top: 0;
    float: none;
    margin-top: 0px;
    padding-top: 0px;
    visibility: visible!important;
    overflow: visible!important;
    max-width: 100%;
  }

  .canvas.carousel div.active .frame-holder {
    height: 600px;
    width: 100%;
    overflow: hidden;
  }

  .canvas.carousel div.active {
    height: 600px;
    width: calc((100% - 80px) / 3);
    margin-bottom: 60px;
  }

  .canvas .title .badge {
    margin-left: 0px;
    padding: 0px;
    margin-right: 5px;
  }

  .canvas .title {
    font-size: .7em;
  }

}
</style>